import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../components/Button'
import HeadlinesFields from '../GoogleAssetGroup/Fields/HeadlinesFields'

import { CLICK_THROUGH_LINK, DESCRIPTIONS_LIST, HEADLINES_LIST } from '../fields'

import useStyles from '../../../../styles/common/stepForms'

const stepFields = [HEADLINES_LIST]

function HeadlinesStep({ formik, handleStepChange, showPreview = true }) {
  const { t } = useTranslation()
  const commonClasses = useStyles()

  const { values } = formik

  const clickThroughLink = values[CLICK_THROUGH_LINK]
  const headlinesList = values[HEADLINES_LIST]
  const descriptionList = values[DESCRIPTIONS_LIST]

  const adPreviewValues = useMemo(
    () => ({
      [CLICK_THROUGH_LINK]: clickThroughLink,
      [HEADLINES_LIST]: headlinesList,
      [DESCRIPTIONS_LIST]: descriptionList
    }),
    [clickThroughLink, headlinesList, descriptionList]
  )

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields, values)
  }, [handleStepChange, values])

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Add up to 5 headlines (at least 3)')}</div>
      <div className={commonClasses.stepBody}>
        <HeadlinesFields formik={formik} adPreviewValues={adPreviewValues} showPreview={showPreview} />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

HeadlinesStep.propTypes = {
  handleStepChange: PropTypes.func
}

export default HeadlinesStep
